import * as actionTypes from './toasts.action-types';
import { createAction } from 'typesafe-actions';
import { Toast } from './toast';

export const addToast = createAction(actionTypes.ADD_TOAST)<
  Omit<Toast, 'id'>
>();
export const disposeToast = createAction(actionTypes.DISPOSE_TOAST)<string>();
